// Svelte 5 no longer needs svelte/store imports for basic reactivity

/**
 * State for additional timeline tracks the user has chosen to display alongside
 * the primary (active) event group. The primary track is always derived from
 * `projectState.selected` and is NOT stored in `additional`.
 *
 * Each entry in `additional` is an event group index into `eventGroupState`.
 */
export const timelineTracksState = $state({
    additional: []
});

/**
 * Add an event group index as an additional timeline track.
 *
 * The optional `primaryIndex` parameter is accepted for backwards-compatible
 * call sites but no longer used to short-circuit the add: the primary group
 * is filtered out at render time in `Timeline.svelte`. This lets the user
 * mark the currently selected group as additional before switching primary,
 * which mirrors the legacy "Set as Track 2" workflow.
 *
 * @param {number} eventGroupIndex
 * @param {number} [primaryIndex]
 */
// eslint-disable-next-line no-unused-vars
export function addTrack(eventGroupIndex, primaryIndex) {
    const idx = Number(eventGroupIndex);
    if (!Number.isFinite(idx) || idx < 0) return;
    if (timelineTracksState.additional.includes(idx)) return;
    timelineTracksState.additional.push(idx);
}

/**
 * Remove an event group index from additional tracks.
 * @param {number} eventGroupIndex
 */
export function removeTrack(eventGroupIndex) {
    const idx = Number(eventGroupIndex);
    const position = timelineTracksState.additional.indexOf(idx);
    if (position !== -1) {
        timelineTracksState.additional.splice(position, 1);
    }
}

/**
 * Replace the full additional-tracks list (used when loading a project).
 * @param {number[]} indices
 */
export function setAdditionalTracks(indices) {
    timelineTracksState.additional.length = 0;
    if (!Array.isArray(indices)) return;
    indices.forEach((idx) => {
        const value = Number(idx);
        if (Number.isFinite(value) && value >= 0 && !timelineTracksState.additional.includes(value)) {
            timelineTracksState.additional.push(value);
        }
    });
}

/**
 * Clear all additional tracks.
 */
export function resetTimelineTracksState() {
    timelineTracksState.additional.length = 0;
}
